module.exports = __webpack_public_path__ + "img/About_ys_big_6.82a2ceda.jpg";